export default __webpack_public_path__ + "static/media/gallery-wip-handle_11.a99692fd.jpg";